import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid, Typography } from 'components/ui';

const Welcome = ({ user, children }) => {
  const userName = useMemo(() => {
    if (user.name || user.surname) {
      return `${user.name} ${user.surname}`;
    }
    return user.email;
  }, [user]);

  return (
    <Grid container>
      <Grid size={{ xs: 12, md: 6 }}>
        <Typography variant="h6" gutterBottom>
          <FormattedMessage id="dashboard.welcome" values={{ name: userName }} />
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }} sx={{ mb: 2 }} justifyContent='right'>
        {children}
      </Grid>
    </Grid>
  );
};

export default Welcome;
